module.exports = __webpack_public_path__ + "img/d200705b-3.fd791ae2.jpg";